import { render, staticRenderFns } from "./Dash-navbar.vue?vue&type=template&id=19d2c4cc"
import script from "./Dash-navbar.vue?vue&type=script&lang=js"
export * from "./Dash-navbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports